import store from '@/store/index'
import api from '@/apis/index'
import ddApi from '@/apis/dingding'
import { getCorpKey } from './url'

export default function getCorpId () {
  return api.request(
    ddApi.getCorpId,
    { corpKey: getCorpKey() }
  ).then(res => {
    const corpId = res.data || ''
    store.commit('SET_CORPID', corpId)
    return corpId
  })
}



// WEBPACK FOOTER //
// ./src/utils/getCorpId.js